// extracted by mini-css-extract-plugin
export default {"wrapper":"defaults_wrapper__AQvvz"};